import { Button, IconButton } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Edit, PersonAdd } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Alert, Box, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Snackbar } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import Popup from "../components/Popup";
import ApiServices from "../services/ApiServices";
import RegisterUser from "./RegisterUser";
import { isAdmin, getCurrentUserEmail } from "../components/Constants";

function Users(props) {

    const columns = [
        {
            field: 'firstName', headerName: 'First name', flex: 0.7, sortable: false, renderCell: (params) => {
                return <div style={{ lineHeight: "1.2", overflowWrap: "break-word", whiteSpace: "normal", overflow: "auto", maxHeight: "inherit" }}>{params.row.firstName}</div>
            }
        },
        {
            field: 'lastName', headerName: 'Last name', flex: 0.7, sortable: false, renderCell: (params) => {
                return <div style={{ lineHeight: "1.2", overflowWrap: "break-word", whiteSpace: "normal", overflow: "auto", maxHeight: "inherit" }}>{params.row.lastName}</div>
            }
        },
        { field: 'email', headerName: 'Email', flex: 0.9, sortable: false, },
        {
            field: 'createdAt', headerName: 'Created at', flex: 0.5, sortable: false, renderCell: (params) => {
                if (params.row.createdAt) {
                    return moment(params.row.createdAt).format("DD-MM-YYYY h:mm:ss a");
                }
            }
        },
        {
            field: 'action', headerName: 'Action', flex: 0.4, sortable: false,            
            renderCell: (params) => {
                if (isAdmin()) {
                    return <div>
                        <IconButton aria-label="delete" sx={{ m: 1 }} onClick={(e) => deleteClicked(params.row.id)}>
                            <DeleteIcon sx={{ textAlign: 'center', color: 'red' }} />
                        </IconButton>
                        <IconButton aria-label="edit" color='primary' onClick={(e) => editClicked(params.row.id)}>
                            <Edit />
                        </IconButton>
                    </div>
                }
                else if (getCurrentUserEmail() === params.row.email) {
                    return <IconButton aria-label="edit" color='primary' onClick={(e) => editClicked(params.row.id)}>
                        <Edit />
                    </IconButton>
                }
            }

        }

    ];
    const [users, setUsers] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    const [openPopup, setOpenPopup] = useState(false);
    const [alert, setOpenAlert] = useState(false);
    const [alertObj, setAlertObj] = useState({ open: false, severity: "error", message: "" });
    const [deleteRowId, setDeleteRowId] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [editRowId, setEditRowId] = useState(null);

    const closeAlert = () => {
        setOpenAlert(false);
    };

    const deleteClicked = (id) => {
        setOpenAlert(true);
        setDeleteRowId(id);
    }

    const editClicked = (id) => {
        setEditRowId(id);
        setEditMode(true);
        setOpenPopup(true);
    }

    const openRegisterForm = () => {
        setEditMode(false);
        setOpenPopup(true);
    }

    const submittedSuccessfully = (isSuccess, msg) => {
        if (isSuccess) {
            setAlertObj({ open: true, severity: "success", message: msg });
            setOpenPopup(false);
            getUsers();
        } else {
            setAlertObj({ open: true, severity: "error", message: msg });
        }
    }

    const deleteUser = () => {
        ApiServices.deleteUser(deleteRowId)
            .then(response => {
                if (response.status === 200) {
                    closeAlert();
                    setAlertObj({ open: true, severity: "success", message: response.data });
                    getUsers();
                }
            })
            .catch(error => {
                setAlertObj({ open: false, severity: "error", message: error.response.data });
            })

    }
    const getUsers = () => {
        ApiServices.getUsers()
            .then(response => {
                if (response.status === 200) {
                    setUsers(response.data);
                } else {
                    setUsers([]);
                }
            })
            .catch(error => {
                console.error(error);
                setUsers([]);
            })
    }

    const handleClose = () => {
        setAlertObj({ open: false });
    };

    useEffect(() => {
        getUsers();
    }, [])
    return (
        <Container maxWidth='lg'>

            <Box
                component="span"
                display="inline-block"
                textAlign="right"
                sx={{
                    '& > :not(style)': { m: 1 },
                    width: "100%"
                }}>
                <Button variant="contained" color="primary" onClick={openRegisterForm}><PersonAdd /></Button>
            </Box>
            <Box mt={1} justifyContent='center'>
                <DataGrid
                    getRowId={(row) => row.id}
                    rows={users}
                    columns={columns}
                    disableColumnMenu
                    autoHeight={true}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 25, 50]}
                    pagination
                    disableSelectionOnClick
                />
            </Box>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                autoHideDuration={2000}
                open={alertObj.open}
                onClose={handleClose}
            >
                <Alert severity={alertObj.severity} sx={{ width: '100%' }}>
                    {alertObj.message}
                </Alert>
            </Snackbar>

            <Popup
                title={editMode ? 'Update User' : 'Register new User'}
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
            >
                <RegisterUser submittedSuccessfully={submittedSuccessfully} editMode={editMode} editRowId={editRowId} />
            </Popup>

            <Dialog
                open={alert}
                onClose={closeAlert}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Are You Sure?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        User will be deleted
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeAlert}>Disagree</Button>
                    <Button onClick={deleteUser} autoFocus>
                        Agree
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
}

export default Users;